import type * as SchemaTypes from '../types';

import type { DealerTranslatedStringSettingDataFragment } from './DealerTranslatedStringData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { DealerTranslatedStringSettingDataFragmentDoc } from './DealerTranslatedStringData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type AppointmentModuleEmailContentSpecsFragment = (
  { __typename: 'AppointmentModuleEmailContent' }
  & { subject: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ), introTitle: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ), introImage?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )>, contentText: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ) }
);

export type AppointmentModuleEmailContentFinderReservationSpecsFragment = (
  { __typename: 'AppointmentModuleEmailContentFinderReservation' }
  & { subject: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ), introTitle: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ), introImage?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )>, contentText: (
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  ), listTestDriveTitle?: SchemaTypes.Maybe<(
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  )>, listTestDriveItem?: SchemaTypes.Maybe<(
    { __typename: 'DealerTranslatedStringSetting' }
    & DealerTranslatedStringSettingDataFragment
  )> }
);

export type AppointmentModuleEmailContentCustomerSpecsFragment = (
  { __typename: 'AppointmentModuleEmailContentCustomer' }
  & { submitConfirmation: (
    { __typename: 'AppointmentModuleEmailContent' }
    & AppointmentModuleEmailContentSpecsFragment
  ), bookingConfirmation: (
    { __typename: 'AppointmentModuleEmailContent' }
    & AppointmentModuleEmailContentSpecsFragment
  ), bookingAmendment: (
    { __typename: 'AppointmentModuleEmailContent' }
    & AppointmentModuleEmailContentSpecsFragment
  ), endTestDrive: (
    { __typename: 'AppointmentModuleEmailContent' }
    & AppointmentModuleEmailContentSpecsFragment
  ) }
);

export type AppointmentModuleEmailContentSalesPersonSpecsFragment = (
  { __typename: 'AppointmentModuleEmailContentSalesPerson' }
  & { submitConfirmation: (
    { __typename: 'AppointmentModuleEmailContent' }
    & AppointmentModuleEmailContentSpecsFragment
  ), finderReservation: (
    { __typename: 'AppointmentModuleEmailContentFinderReservation' }
    & AppointmentModuleEmailContentFinderReservationSpecsFragment
  ) }
);

export type AppointmentModuleEmailContentsSpecsFragment = (
  { __typename: 'AppointmentModuleEmailContents' }
  & { customer: (
    { __typename: 'AppointmentModuleEmailContentCustomer' }
    & AppointmentModuleEmailContentCustomerSpecsFragment
  ), salesPerson: (
    { __typename: 'AppointmentModuleEmailContentSalesPerson' }
    & AppointmentModuleEmailContentSalesPersonSpecsFragment
  ) }
);

export const AppointmentModuleEmailContentSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentModuleEmailContentSpecs on AppointmentModuleEmailContent {
  subject {
    ...DealerTranslatedStringSettingData
  }
  introTitle {
    ...DealerTranslatedStringSettingData
  }
  introImage {
    ...UploadFileWithPreviewFormData
  }
  contentText {
    ...DealerTranslatedStringSettingData
  }
}
    `;
export const AppointmentModuleEmailContentCustomerSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentModuleEmailContentCustomerSpecs on AppointmentModuleEmailContentCustomer {
  submitConfirmation {
    ...AppointmentModuleEmailContentSpecs
  }
  bookingConfirmation {
    ...AppointmentModuleEmailContentSpecs
  }
  bookingAmendment {
    ...AppointmentModuleEmailContentSpecs
  }
  endTestDrive {
    ...AppointmentModuleEmailContentSpecs
  }
}
    `;
export const AppointmentModuleEmailContentFinderReservationSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentModuleEmailContentFinderReservationSpecs on AppointmentModuleEmailContentFinderReservation {
  subject {
    ...DealerTranslatedStringSettingData
  }
  introTitle {
    ...DealerTranslatedStringSettingData
  }
  introImage {
    ...UploadFileWithPreviewFormData
  }
  contentText {
    ...DealerTranslatedStringSettingData
  }
  listTestDriveTitle {
    ...DealerTranslatedStringSettingData
  }
  listTestDriveItem {
    ...DealerTranslatedStringSettingData
  }
}
    `;
export const AppointmentModuleEmailContentSalesPersonSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentModuleEmailContentSalesPersonSpecs on AppointmentModuleEmailContentSalesPerson {
  submitConfirmation {
    ...AppointmentModuleEmailContentSpecs
  }
  finderReservation {
    ...AppointmentModuleEmailContentFinderReservationSpecs
  }
}
    `;
export const AppointmentModuleEmailContentsSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment AppointmentModuleEmailContentsSpecs on AppointmentModuleEmailContents {
  customer {
    ...AppointmentModuleEmailContentCustomerSpecs
  }
  salesPerson {
    ...AppointmentModuleEmailContentSalesPersonSpecs
  }
}
    `;